<template>
  <v-container id="registration" fluid>
    <v-row align="center" justify="center">
      <v-col xs="12" sm="8" md="6">
        <v-card flat>
          <v-card-title>
            <!-- <v-img
              alt="Sharylist Logo"
              contain
              class="mr-2"
              src="@/assets/logo.png"
              transition="scale-transition"
              max-width="35"
            />-->
            Register your account
          </v-card-title>
          <v-card-text>
            <v-alert v-show="userAlreadyRegistered" color="error" dense outlined>
              The email you entered is already registered
              <!-- , please procede to log in.
              <v-btn icon large color="secondary" to="/login">
                <v-icon>mdi-login</v-icon>
              </v-btn> -->
            </v-alert>

            <v-form ref="form" v-model="formIsValid">
              <v-text-field
                :rules="rules.firstName"
                v-model="newUser.firstName"
                id="firstName"
                label="First name"
                name="firstName"
                required
                solo
                autofocus
              />
              <v-text-field
                :rules="rules.lastName"
                v-model="newUser.lastName"
                id="lastName"
                label="Last name"
                name="lastName"
                required
                solo
              />
              <v-text-field
                :rules="rules.email"
                v-model="newUser.email"
                id="email"
                label="Email"
                name="email"
                type="email"
                required
                solo
              />
              <v-checkbox
                v-model="newUser.termsAccepted"
                :rules="rules.termsAccepted"
                class="mr-2"
                required
              >
                <template #label>
                  <span>
                    I agree to the Sharylist
                    <a target="_blank" href="/terms.html" @click.stop>terms and conditions</a>
                    and
                    <a
                      target="_blank"
                      href="https://www.iubenda.com/privacy-policy/53958737"
                      @click.stop
                      >privacy policy.</a
                    >
                  </span>
                </template>
              </v-checkbox>

              <!-- <v-checkbox
                v-model="newUser.privacyAccepted"
                :rules="rules.privacyAccepted"
                class="mr-2"
                label="I agree to the privacy terms"
                required
              >
              </v-checkbox>-->
              <v-checkbox
                v-model="newUser.mailinglistAccepted"
                class="mr-2"
                label="I agree to be updated with the lastest Sharylist news"
              ></v-checkbox>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-container>
              <v-btn
                :disabled="!formIsValid"
                outlined
                block
                color="primary"
                @click="userRegistration"
                >Sign up</v-btn
              >
              <!-- <v-spacer></v-spacer>
            <v-btn
              :disabled="!formIsValid"
              icon
              large
              color="primary"
              @click="userRegistration"
            >
              <v-icon> mdi-send </v-icon>
            </v-btn>-->
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'

import Logger from '@/lib/Logger'

import User from '@/models/User.js'

export default {
  data() {
    return {
      formIsValid: false,
      newUser: {
        firstName: '',
        lastName: '',
        email: '',
        termsAccepted: false,
        mailinglistAccepted: false,
      },
      rules: {
        firstName: [v => !!v || 'Required', v => (v && v.length <= 32) || 'Max 32 characters'],
        lastName: [v => !!v || 'Required', v => (v && v.length <= 32) || 'Max 32 characters'],
        email: [v => !!v || 'Required', v => /.+@.+\..+/.test(v) || 'E-mail must be valid'],
        termsAccepted: [v => !!v || 'Required'],
      },
      userAlreadyRegistered: false,
    }
  },

  mounted() {
    this.errorsDataAccessAllSetFalse()
    this.nodeCurrentSet({})
  },

  methods: {
    goToRegistrationAcklowledge() {
      this.$router.push({
        name: 'RegistrationAcknowledge',
        params: { newUser: this.newUser },
      })
    },
    async userRegistration() {
      if (this.formIsValid) {
        try {
          const u = await User.register(this.newUser, this.$route.query)
          Logger.debug('registration result', u)
          this.$gtag.set({ user_id: u.id })
          Logger.debug('gtag config user_id:', u.id)
          this.$gtag.event('sign_up', {
            event_label: this.newUser.email,
          })
          this.goToRegistrationAcklowledge()
        } catch (e) {
          if (e.name == 'USER_ALREADY_REGISTERED') {
            this.userAlreadyRegistered = true
            this.$gtag.exception({
              description: 'registration USER_ALREADY_REGISTERED for user: ' + this.newUser.email,
              fatal: false,
            })
            // this.$refs.form.reset()
          } else {
            Logger.error(e)
            this.$gtag.exception({
              description: 'registration unknown falure for user: ' + this.newUser.email + e,
              fatal: false,
            })
            this.toastSet({
              message: 'Error in user registration',
              color: 'error',
            })
          }
        }
      } else {
        this.toastSet({
          message: 'Error in form fields validation',
          color: 'error',
        })
      }
    },
    ...mapMutations(['nodeCurrentSet', 'toastSet', 'errorsDataAccessAllSetFalse']),
  },
}
</script>
